import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { SITE } from "@/config/site";

export const WhatsAppFloat = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const el = document.getElementById("contacto");
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => setHidden(entry.isIntersecting), { threshold: 0.12 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <motion.a
      data-testid="floating-whatsapp-button"
      href={SITE.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Hablar por WhatsApp"
      initial={{ opacity: 0, scale: 0 }}
      animate={hidden ? { opacity: 0, scale: 0 } : { opacity: 1, scale: 1 }}
      transition={hidden ? { duration: 0.25 } : { delay: 1.6, type: "spring", stiffness: 200, damping: 16 }}
      whileHover={{ scale: hidden ? 0 : 1.1 }}
      whileTap={{ scale: hidden ? 0 : 0.92 }}
      style={{ pointerEvents: hidden ? "none" : "auto" }}
      className="fixed bottom-20 right-4 sm:bottom-6 sm:right-6 z-50 w-12 h-12 sm:w-[60px] sm:h-[60px] rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_10px_35px_rgba(37,211,102,0.45)]"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
      <MessageCircle size={24} className="text-white relative sm:w-7 sm:h-7" fill="white" />
    </motion.a>
  );
};
